
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputReusable } from '../input-reusable/input-reusable';

@Component({
  selector: 'app-interview-question-block',
  standalone: true,
  imports: [InputReusable],
  templateUrl: './interview-question-block.html',
  styles: [
    `
      :host {
        display: block;
      }

      .question-display {
        height: auto;
        overflow: visible;
        overflow-wrap: anywhere;
        white-space: normal;
        word-break: break-word;
      }
    `,
  ],
})
export class InterviewQuestionBlock {
  @Input() questionLabel = 'Question';
  @Input() required = false;
  @Input() questionReadonly = true;
  @Input() questionControl = new FormControl<string>('', { nonNullable: true });

  @Input() commentLabel = 'Comments';
  @Input() commentPlaceholder: string | undefined =
    'Capture key response, example and assessment of the applicant....';
  @Input() commentControl = new FormControl<string>('', { nonNullable: true });
  @Input() maxCommentLength = 500;
  @Input() requiredErrorMessage = 'This field is mandatory';

  get questionText(): string {
    return String(this.questionControl?.value ?? '');
  }

  get commentCount(): number {
    return this.commentControl?.value?.length ?? 0;
  }

  get commentErrorMessage(): string {
    if (
      this.required &&
      this.commentControl?.hasError('required') &&
      (this.commentControl.touched || this.commentControl.dirty)
    ) {
      return this.requiredErrorMessage;
    }

    return '';
  }
}
